import React, { useContext, useEffect, useRef } from 'react';
import AnnouncerContext from "./AnnouncerContext";
import { LiveRegionRole } from "./interfaces";
import { jsx as ___EmotionJSX } from "@emotion/core";
var ANNOUNCE_TIMEOUT = 1000;
var CLEAR_REGION_TIMEOUT = 2000;

var LiveRegion = function LiveRegion(_ref) {
  var ariaLive = _ref['aria-live'],
      role = _ref.role,
      children = _ref.children;

  var _useContext = useContext(AnnouncerContext),
      announceAssertive = _useContext.announceAssertive,
      announcePolite = _useContext.announcePolite;

  var timerId = useRef(null);
  useEffect(function () {
    var functionsMap = {
      polite: announcePolite,
      assertive: announceAssertive
    };
    var announceFn = functionsMap[ariaLive];

    if (announceFn) {
      if (timerId.current) {
        window.clearTimeout(timerId.current);
      }

      timerId.current = window.setTimeout(function () {
        announceFn({
          region: children,
          role: role
        });
        timerId.current = window.setTimeout(function () {
          announceFn({
            region: '',
            role: role
          });
        }, CLEAR_REGION_TIMEOUT);
      }, ANNOUNCE_TIMEOUT);
    } // Specify how to clean up aria regions.


    return function cleanup() {
      if (timerId.current) {
        window.clearTimeout(timerId.current);
      }

      Object.values(LiveRegionRole).map(function (role) {
        announcePolite({
          region: '',
          role: role
        });
        announceAssertive({
          region: '',
          role: role
        });
        return null;
      });
    };
  }, [children, announceAssertive, announcePolite, ariaLive, role]);
  return ___EmotionJSX(React.Fragment, null, children);
};

export { CLEAR_REGION_TIMEOUT };
export default LiveRegion;